import React, { useEffect, useState } from "react";
import {
    ContainerInfo,
    BoxInfo,
    BoxSubInfo,
    BoxSubInfo2,
    ImgProduct,
    SelecaoList,
    ImgSelecaoProduct,
    NomeProduto,
    BoxInfoProduto1,
    BoxInfoProduto2,
    ValorPrincipal,
    DescricaoPrincipal,
    TamanhoP,
    BoxTamanhoProduto,
    TamanhoProduto,
    TP,
    CorP,
    BoxInfoProduto3,
    AddCarrinho,
    AddCarrinhoP,
    BtnCarrinho
} from '../ProductPrincip.style.js';
import Carrinho from '../../components/svg/carrinho.svg';
import axios from "axios";
import apiService from "../../api/home.js";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactImageMagnify from 'react-image-magnify';
import bigArrow from '../assets/bigArrow.png'
import Loading from '../assets/loading.gif';
import { horizontalScale } from "../../Utils/responsive_metrics.js";

function DetalheProduto({ }) {

    const [produtoAPI, setProdutoAPI] = useState({})
    const [tamanhoImagem, setTamanhoImagem] = useState(450)
    const [over, setOver] = useState('beside')
    const [imagemSelecionada, setImagemSelecionada] = useState(null)
    const [produtovariacao, setProdutovariacao] = useState([])
    const [etiquetaSelected, setEtiquetaSelected] = useState([])
    const [produtovariacaoSelected, setProdutovariacaoSelected] = useState([])

    useEffect(() => {
        listarProdutos();
    }, [])

    const handleResize = () => {
        const width = window.innerWidth;

        if (width > 1024) {
            setTamanhoImagem(450)
            setOver('beside')
            return false;
        }

        if (width < 700) {
            setTamanhoImagem(250)
            setOver('over')
            return false;
        }

        setTamanhoImagem(400)
        setOver('beside')

    };

    useEffect(() => {
        // Adiciona o listener do evento de redimensionamento
        window.addEventListener('resize', handleResize);

        // Chama a função imediatamente para registrar o tamanho inicial
        handleResize();

        // Remove o listener ao desmontar o componente
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Executa o efeito apenas uma vez ao montar o componente

    const listarProdutos = async () => {
        try {
            const getAmbiente = apiService.ambiente();

            var url_amigavel = window.location.pathname;

            var endpoint = getAmbiente + '/integracao/site' + url_amigavel

            console.log(endpoint, 'endpoint')

            var getDominio = apiService.obterDominio()

            const response = await axios.post(
                endpoint,
                {
                    dominio: getDominio,
                    idcategoriasite: ""
                }
            );
            console.log('Dados recebidos:', response.data.retorno.produtos);

            const semVariacao = response.data.retorno.produtos[0];
            const allVariacaoEtiqueta = response.data.retorno.produtos[0].variacoes;

            // Agrupando por "etiqueta"
            const groupedByEtiqueta = allVariacaoEtiqueta.reduce((acc, item) => {
                const informacaoetiqueta = item.informacaoetiqueta || "Padrão"; // Usar "Sem Etiqueta" caso não tenha etiqueta
                if (!acc[informacaoetiqueta]) {
                    acc[informacaoetiqueta] = [];
                }
                acc[informacaoetiqueta].push(item);
                return acc;
            }, {});

            setProdutovariacao(groupedByEtiqueta)
            const primeiraEtiqueta = Object.keys(groupedByEtiqueta)[0]; // Pega o nome da primeira etiqueta 
            setEtiquetaSelected(groupedByEtiqueta[primeiraEtiqueta]);

            if (response.data.retorno.produtos.length > 1) {
                const normalizePath = (path) => path.replace(/^\/+/, '');
                const currentPath = normalizePath(window.location.pathname);
                const produto = response.data.retorno.produtos.find((i) =>
                    normalizePath(i.urlproduto) === currentPath
                );
                setProdutoAPI(produto)
            } else {
                setProdutoAPI(response.data.retorno.produtos[0])
            }

        } catch (error) {
            console.error('Erro ao listar produtos:', error);
        }
    };

    function renderImg(imgPrincipal, fotos) {
        const getAmbiente = apiService.ambiente();

        // nao existe foto princiapl usa  a foto secundaria
        if (imgPrincipal == null) {

            if (fotos && fotos.length > 0) {
                imgPrincipal = fotos[0].urlfoto
            }

        }
        var get_item_url = imgPrincipal;
        var url = getAmbiente + "/" + get_item_url

        return url;
    }

    useEffect(() => {
        // Atualiza o produtoAPI.idproduto sempre que produtovariacaoSelected.idprodutovariacao muda
        if (produtovariacaoSelected?.idprodutovariacao) {
            setProdutoAPI((prev) => ({
                ...prev,
                idproduto: produtovariacaoSelected.idprodutovariacao,
            }));
        }
    }, [produtovariacaoSelected]);

    useEffect(() => {
        if (etiquetaSelected) {
            setProdutovariacaoSelected(etiquetaSelected[0]);
        }
    }, [etiquetaSelected])

    const adicionarCarrinho = async () => {
        var produto = produtoAPI;

        console.log('produtoAPI', produtoAPI);

        if (personalizacaoValores) {
            produto.personalizacao = personalizacaoValores;
        }

        console.log('produto', produto);

        // Recupera o carrinho existente no localStorage ou inicializa como um array vazio
        const carrinho = JSON.parse(localStorage.getItem('@carrinho')) || [];

        // Verifica se o produto já está no carrinho
        const produtoExistente = carrinho.find(item => item.idproduto === produto.idproduto);

        if (produtoExistente) {
            // Incrementa a quantidade do produto existente
            produtoExistente.quantidade = (produtoExistente.quantidade || 1) + 1;
        } else {
            // Adiciona o novo produto com a quantidade inicial de 1
            carrinho.push({ ...produto, quantidade: 1 });
        }

        // Atualiza o localStorage com o carrinho atualizado
        localStorage.setItem('@carrinho', JSON.stringify(carrinho));

        toast.success('Item adicionado no carrinho!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

        await sleep(1500)
        window.atualizarCarrinho("abrirCarrinho");
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const nextImage = () => {
        if (produtoAPI?.fotos && produtoAPI.fotos.length > 0) {
            const currentIndex = produtoAPI.fotos.findIndex(i => i.urlfoto === imagemSelecionada);
            const nextIndex = (currentIndex + 1) % produtoAPI.fotos.length;
            setImagemSelecionada(produtoAPI.fotos[nextIndex].urlfoto);

            // Obtém o contêiner de rolagem
            const container = document.getElementById('scroll-container');
            const nextImageElement = document.getElementById(`foto-${nextIndex}`);
            if (container && nextImageElement) {
                container.scrollTo({
                    left: nextImageElement.offsetLeft - container.offsetLeft,
                    behavior: 'smooth',
                });
            }
        }
    };

    const prevImage = () => {
        if (produtoAPI?.fotos && produtoAPI.fotos.length > 0) {
            const currentIndex = produtoAPI.fotos.findIndex(i => i.urlfoto === imagemSelecionada);
            const prevIndex = (currentIndex - 1 + produtoAPI.fotos.length) % produtoAPI.fotos.length;
            setImagemSelecionada(produtoAPI.fotos[prevIndex].urlfoto);

            // Obtém o contêiner de rolagem
            const container = document.getElementById('scroll-container');
            const prevImageElement = document.getElementById(`foto-${prevIndex}`);
            if (container && prevImageElement) {
                container.scrollTo({
                    left: prevImageElement.offsetLeft - container.offsetLeft,
                    behavior: 'smooth',
                });
            }
        }
    };

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        updateDimensions();
        window.addEventListener('resize', updateDimensions);

        return () => {
            window.removeEventListener('resize', updateDimensions);
        };
    }, []);

    const updateDimensions = () => {
        setIsMobile(window.innerWidth <= 950);
    };

    const [mouseOn, setMouseOn] = useState(false);

    function capitalizeFirstLetter(text) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    const [personalizacaoValores, setPersonalizacaoValores] = useState({});

    const handleChange = (id, value) => {
        // Verificar se id.idprodutopersonalizacao é válido
        const idProdutopersonalizacao = id?.idprodutopersonalizacao;
        if (!idProdutopersonalizacao) {
            console.error('id.idprodutopersonalizacao não encontrado');
            return;
        }
        setPersonalizacaoValores(prev => ({
            ...prev,
            [idProdutopersonalizacao]: {
                idprodutopersonalizacao: idProdutopersonalizacao,
                texto: typeof value === "string" ? value : "",
                idprodutopersonalizacaoopcao: value?.idprodutopersonalizacaoopcao || ""
            }
        }));
    };

    return (
        <ContainerInfo>
            <BoxInfo>
                <BoxSubInfo style={{
                    width: isMobile ? horizontalScale(290) : horizontalScale(131),
                    maxWidth: isMobile ? '400px' : '506px',
                }}>
                    {/* Adiciona a funcionalidade de lupa */}

                    {isMobile ?
                        <ReactImageMagnify
                            {...{
                                smallImage: {
                                    width: isMobile ? horizontalScale(290) : horizontalScale(131),
                                    height: 450,
                                    alt: produtoAPI.tituloloja,
                                    src: imagemSelecionada == null ? renderImg(produtoAPI.urlfotoprincipal, produtoAPI.fotos) : renderImg(imagemSelecionada),
                                },

                                enlargedImagePosition: over,//over(mobile)
                                largeImage: {
                                    src: imagemSelecionada == null ? renderImg(produtoAPI.urlfotoprincipal, produtoAPI.fotos) : renderImg(imagemSelecionada),
                                    width: 1200,
                                    height: 1200,
                                },
                            }}
                        />
                        :
                        <ImgProduct style={{
                            width: isMobile ? horizontalScale(290) : horizontalScale(131),
                            maxWidth: isMobile ? '400px' : '506px',
                            position: 'relative'
                        }}>
                            {produtoAPI?.urlproduto ?
                                <>
                                    {mouseOn ?
                                        <div
                                            style={{
                                                width: isMobile ? horizontalScale(290) : horizontalScale(131),
                                                maxWidth: isMobile ? '400px' : '506px',
                                                height: '450px',
                                                objectFit: 'cover'
                                            }}
                                            onMouseLeave={() => setMouseOn(false)} // Sai do zoom ao tirar o mouse
                                        >
                                            <ReactImageMagnify
                                                {...{
                                                    smallImage: {
                                                        width: tamanhoImagem,
                                                        height: 450,
                                                        alt: produtoAPI.tituloloja,
                                                        src: imagemSelecionada == null ? renderImg(produtoAPI.urlfotoprincipal, produtoAPI.fotos) : renderImg(imagemSelecionada),
                                                    },

                                                    enlargedImagePosition: over,//over(mobile)
                                                    largeImage: {
                                                        src: imagemSelecionada == null ? renderImg(produtoAPI.urlfotoprincipal, produtoAPI.fotos) : renderImg(imagemSelecionada),
                                                        width: 1200,
                                                        height: 1200,
                                                    },
                                                }}
                                            />
                                        </div>
                                        :
                                        <img
                                            onMouseEnter={() => setMouseOn(true)}
                                            src={imagemSelecionada == null ? renderImg(produtoAPI?.urlfotoprincipal, produtoAPI?.fotos) : renderImg(imagemSelecionada)}
                                            style={{
                                                width: isMobile ? horizontalScale(290) : horizontalScale(131),
                                                maxWidth: isMobile ? '400px' : '506px',
                                                height: '450px',
                                                objectFit: 'cover'
                                            }}
                                            alt={produtoAPI.legenda}
                                        />
                                    }
                                </>
                                :
                                <div style={{
                                    width: '506px',
                                    height: '450px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#8484848A',
                                    borderRadius: '20px'
                                }}>
                                    <img style={{ width: 20, height: 20 }} src={Loading} />
                                </div>
                            }
                        </ImgProduct>}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'relative'
                        }}>
                        {produtoAPI?.fotos?.length > 1 ? <img
                            onClick={prevImage}
                            src={bigArrow} style={{
                                left: -30,
                                position: 'absolute',
                                width: '11.93px',
                                height: '22.03px',
                                cursor: 'pointer',
                                transform: 'rotateY(180deg)',
                                filter: 'brightness(0)',
                                paddingLeft: '15px',
                            }} /> : null}
                        {produtoAPI?.fotos?.length > 1 ?
                            <div
                                id="scroll-container"
                                style={{
                                    width: '100%',
                                    overflowX: 'auto',
                                    whiteSpace: 'nowrap',
                                    borderWidth: 1,
                                    scrollbarWidth: 'thin', // Para navegadores que suportam esta propriedade
                                    scrollbarColor: '#848484 transparent', // Cor personalizada (opcional)
                                }}>
                                <SelecaoList style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '12px',
                                }}>
                                    {produtoAPI?.fotos?.map((i, index) => (
                                        <ImgSelecaoProduct key={index} id={`foto-${index}`} onClick={() => setImagemSelecionada(i.urlfoto)}>
                                            <img
                                                src={renderImg(i.urlfoto, i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    width: imagemSelecionada === i.urlfoto ? '96%' : '100%',
                                                    height: imagemSelecionada === i.urlfoto ? '96%' : '100%',
                                                    border: imagemSelecionada === i.urlfoto ? '2px solid #8484848A' : null,
                                                }}
                                                alt={i.legenda}
                                            />
                                        </ImgSelecaoProduct>
                                    ))}
                                </SelecaoList>
                            </div> : null}
                        {produtoAPI?.fotos?.length > 1 ? <img
                            onClick={nextImage}
                            src={bigArrow} style={{
                                right: -30,
                                position: 'absolute',
                                width: '11.93px',
                                height: '22.03px',
                                cursor: 'pointer',
                                filter: 'brightness(0)'
                            }} /> : null}
                    </div>
                </BoxSubInfo>

                <BoxSubInfo2 style={{
                    width: isMobile ? horizontalScale(290) : horizontalScale(131),
                    maxWidth: isMobile ? '400px' : '506px',
                }}>
                    <BoxInfoProduto1>
                        <NomeProduto>{produtoAPI.tituloloja} - {produtoAPI.sku}</NomeProduto>
                        <ValorPrincipal>R$ {produtoAPI.preco}</ValorPrincipal>
                        <DescricaoPrincipal>{produtoAPI.descricaolonga ? produtoAPI.descricaolonga : 'Produto sem descrição'}</DescricaoPrincipal>
                    </BoxInfoProduto1>

                    <BoxInfoProduto2>

                        <div>
                            {etiquetaSelected?.[0] ?
                                <>
                                    <TamanhoP>Tamanhos:</TamanhoP>
                                    <div style={{
                                        width: isMobile ? horizontalScale(290) : horizontalScale(131),
                                        maxWidth: isMobile ? '400px' : '506px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        cursor: 'pointer',
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        borderWidth: 1,
                                        scrollbarWidth: 'thin', // Para navegadores que suportam esta propriedade
                                        scrollbarColor: '#848484 transparent', // Cor personalizada (opcional)
                                    }}>
                                        {etiquetaSelected.map((item) => (
                                            <div onClick={() => setProdutovariacaoSelected(item)}>
                                                <BoxTamanhoProduto>
                                                    <TamanhoProduto style={{
                                                        backgroundColor: produtovariacaoSelected?.idprodutovariacao == item.idprodutovariacao ?
                                                            '#282626' :
                                                            item.estoque > 0 ? '#848484' : '#D2D2D2'
                                                    }}
                                                    >
                                                        <TP>
                                                            {item?.tamanho ? item?.tamanho : 'Padrão'}
                                                        </TP>
                                                    </TamanhoProduto>
                                                </BoxTamanhoProduto>
                                            </div>
                                        ))}
                                    </div>
                                </>
                                :
                                <>
                                    <TamanhoP>Tamanhos:</TamanhoP>
                                    <div style={{
                                        width: isMobile ? horizontalScale(290) : horizontalScale(131),
                                        maxWidth: isMobile ? '400px' : '506px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        cursor: 'pointer',
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        borderWidth: 1,
                                        scrollbarWidth: 'thin', // Para navegadores que suportam esta propriedade
                                        scrollbarColor: '#848484 transparent', // Cor personalizada (opcional)
                                    }}>
                                        <BoxTamanhoProduto>
                                            <TamanhoProduto style={{ backgroundColor: '#282626' }}>
                                                <TP>
                                                    {'Padrão'}
                                                </TP>
                                            </TamanhoProduto>
                                        </BoxTamanhoProduto>
                                    </div>
                                </>
                            }

                            {Object.keys(produtovariacao)?.length > 0 ?
                                <>
                                    <CorP>Cor:</CorP>
                                    <div style={{
                                        width: isMobile ? horizontalScale(290) : horizontalScale(131),
                                        maxWidth: isMobile ? '400px' : '506px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        cursor: 'pointer',
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        borderWidth: 1,
                                        scrollbarWidth: 'thin', // Para navegadores que suportam esta propriedade
                                        scrollbarColor: '#848484 transparent', // Cor personalizada (opcional)
                                    }}>
                                        {Object.keys(produtovariacao)?.map((key) => (
                                            <div
                                                key={key}
                                                onClick={() => setEtiquetaSelected(produtovariacao[key])} // Define a chave como o selecionado
                                                style={{
                                                    padding: '6px 10px',
                                                    marginRight: '5px',
                                                    borderRadius: '5px',
                                                    backgroundColor: etiquetaSelected === produtovariacao[key] ? '#282626' : '#D2D2D2'
                                                }}
                                            >
                                                <text
                                                    style={{
                                                        color: '#FFFFFF',
                                                        fontWeight: 700,
                                                        fontSize: '14px'
                                                    }}
                                                >
                                                    {capitalizeFirstLetter(key)}
                                                </text>
                                            </div>
                                        ))}
                                    </div>
                                </>
                                :
                                <>
                                    <CorP> Cor:</CorP>
                                    <div style={{
                                        width: isMobile ? horizontalScale(290) : horizontalScale(131),
                                        maxWidth: isMobile ? '400px' : '506px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        cursor: 'pointer',
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        borderWidth: 1,
                                        scrollbarWidth: 'thin', // Para navegadores que suportam esta propriedade
                                        scrollbarColor: '#848484 transparent', // Cor personalizada (opcional)
                                    }}>
                                        <div
                                            onClick={() => setEtiquetaSelected(produtovariacao[0])} // Define a chave como o selecionado
                                            style={{
                                                padding: '6px 10px',
                                                marginRight: '5px',
                                                borderRadius: '5px',
                                                backgroundColor: '#282626'
                                            }}
                                        >
                                            <text
                                                style={{
                                                    color: '#FFFFFF',
                                                    fontWeight: 700,
                                                    fontSize: '14px'
                                                }}
                                            >
                                                {'Padrão'}
                                            </text>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>

                        {produtoAPI.personalizavel == 'S' ?
                            <div style={{ gap: '15px', paddingTop: '10px', display: 'flex', flexDirection: 'column' }}>
                                <label style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>Personalizações:</label>
                                {produtoAPI?.personalizacoes?.map((p) => (
                                    <div key={p.idprodutopersonalizacao} style={{ display: 'flex', flexDirection: 'column' }}>
                                        <TamanhoP>{p.produtopersonalizacao}:</TamanhoP>
                                        {p.idprodutopersonalizacaotipo === "2" ? (
                                            <>
                                                <div
                                                    style={{
                                                        width: isMobile ? horizontalScale(290) : horizontalScale(131),
                                                        maxWidth: isMobile ? '400px' : '506px',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        cursor: 'pointer',
                                                        overflowX: 'auto',
                                                        whiteSpace: 'nowrap',
                                                        borderWidth: 1,
                                                        scrollbarWidth: 'thin',
                                                        scrollbarColor: '#848484 transparent',
                                                        gap: '8px',
                                                    }}
                                                >
                                                    {p.opcoes.map((opcao) => (
                                                        <BoxTamanhoProduto key={opcao.idprodutopersonalizacaoopcao} onClick={() => handleChange(p, opcao)} >
                                                            <TamanhoProduto
                                                                style={{
                                                                    backgroundColor:
                                                                        (personalizacaoValores[p.idprodutopersonalizacao]?.idprodutopersonalizacaoopcao === opcao.idprodutopersonalizacaoopcao)
                                                                            ? '#282626'
                                                                            : '#848484',
                                                                    transition: 'background-color 0.3s ease',
                                                                }}
                                                            >
                                                                <TP>{opcao.produtopersonalizacaoopcao}</TP>
                                                            </TamanhoProduto>
                                                        </BoxTamanhoProduto>
                                                    ))}
                                                </div>
                                            </>
                                        ) : p.idprodutopersonalizacaotipo === "1" ? (
                                            <input
                                                type="text"
                                                maxLength={p.quantidadecaracteres}
                                                value={personalizacaoValores[p.idprodutopersonalizacao]?.texto || ""}
                                                onChange={(e) => handleChange(p, e.target.value)}
                                                placeholder="Digite aqui..."
                                                style={{
                                                    width: '174px',
                                                    padding: '12px',
                                                    borderRadius: '8px',
                                                    border: '2px solid #ccc',
                                                    fontSize: '16px',
                                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                                    transition: 'border-color 0.3s ease',
                                                }}
                                                onMouseEnter={(e) => (e.target.style.borderColor = '#007bff')}
                                                onMouseLeave={(e) => (e.target.style.borderColor = '#ccc')}
                                            />
                                        ) : null}
                                    </div>
                                ))}
                            </div>
                            :
                            null
                        }
                    </BoxInfoProduto2>

                    <BoxInfoProduto3>
                        {(() => {
                            const estoqueVar = produtovariacaoSelected?.estoque ?? 0;
                            const estoqueAPI = produtoAPI?.estoque ?? 0;
                            const temEstoque = estoqueVar > 0 || estoqueAPI > 0;
                            const temVariacao = !!produtovariacaoSelected?.idprodutovariacao;

                            return (
                                <>
                                    <AddCarrinho
                                        onClick={() => {
                                            if (temEstoque) {
                                                adicionarCarrinho();
                                            } else {
                                                console.log('cabo!');
                                            }
                                        }}
                                        style={{ backgroundColor: temEstoque ? '#848484' : '#D2D2D2' }}
                                    >
                                        <AddCarrinhoP>
                                            {
                                                !produtovariacaoSelected && estoqueAPI ?
                                                    'Adicionar no carrinho' :
                                                    !temVariacao
                                                        ? 'Escolha uma opção'
                                                        : estoqueVar > 0
                                                            ? 'Adicionar no carrinho'
                                                            : 'Esgotado'}
                                        </AddCarrinhoP>
                                    </AddCarrinho>

                                    <BtnCarrinho
                                        onClick={() => {
                                            if (temEstoque) {
                                                adicionarCarrinho();
                                            } else {
                                                console.log('cabo!');
                                            }
                                        }}
                                    >
                                        <img src={Carrinho} alt="CarrinhoDeCompra" />
                                    </BtnCarrinho>
                                </>
                            );
                        })()}
                    </BoxInfoProduto3>

                </BoxSubInfo2>
            </BoxInfo>
        </ContainerInfo>
    );
}
// produtoAPI
export default DetalheProduto;
